import { render, staticRenderFns } from "./ListTextItem.vue?vue&type=template&id=817c8744&scoped=true"
import script from "./ListTextItem.vue?vue&type=script&lang=js"
export * from "./ListTextItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817c8744",
  null
  
)

export default component.exports